// Sidebar dimensions
export const SIDEBAR_MIN_WIDTH = 320;
export const SIDEBAR_MAX_WIDTH = 600;
export const SIDEBAR_DEFAULT_WIDTH = 420;

// Floating panel dimensions
export const FLOATING_MIN_WIDTH = 320;
export const FLOATING_MAX_WIDTH = 800;
export const FLOATING_DEFAULT_WIDTH = 420;

export const FLOATING_MIN_HEIGHT = 492;
export const FLOATING_MAX_HEIGHT = 900;
export const FLOATING_DEFAULT_HEIGHT = 492;

// Responsive breakpoint - auto-switch to floating below this width
export const RESPONSIVE_BREAKPOINT = 1200;
